var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row font-family-helvetica"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"min-h-400"},[_c('div',{staticClass:"card-body p-0"},[_c('service-detail-form',{on:{"back":function($event){return _vm.$emit('back')},"next":function($event){return _vm.$emit('next')}}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }